import { connect } from 'react-redux';
import { bindActionCreators, Dispatch, Action } from 'redux';

import {
  selectEventCategories, selectEventDetails, selectEventId, selectEventRSVP,
} from 'redux/selectors/events';
import { StateType } from 'types';
import {
  getEventById, updateEventById, getEventRSVP, getEventCategories,
} from 'redux/actions/events';
import { selectUserType } from 'redux/selectors/auth';

const mapStateToProps = (state: StateType) => ({
  event: selectEventDetails(state),
  id: selectEventId(state),
  eventRVSP: selectEventRSVP(state),
  userType: selectUserType(state),
  eventCategories: selectEventCategories(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators({
    getEventById,
    updateEventById,
    getEventRSVP,
    getEventCategories,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps);
